var tool = {
    loadScript: function (url, callback) {
        var document = window.document;
        var script = document.createElement("script");
        script.type = "text/javascript";
        if (script.readyState) { //IE
            script.onreadystatechange = function () {
                if (script.readyState === "loaded" ||
                    script.readyState === "complete") {
                    script.onreadystatechange = null;
                    callback();
                }
            };
        } else {
            script.onload = function () {
                callback();
            };
        }
        script.src = url;
        document.body.appendChild(script);
    },
    loadCss: function (url) {
        var document = window.document;
        var head = document.getElementsByTagName('head')[0];
        var c = document.createElement('link');
        c.rel = "stylesheet";
        c.type = "text/css";
        c.href = url;
        head.appendChild(c);
    },
    getUrlSearch: function(){
        var searchObj = {};
        var searchStr = window.location.search;
        if(searchStr === ''){
            return searchStr;
        }
        $.each(searchStr.replace('?', '').split('&'), function (iSearch, vSearch){
            var searchArr = vSearch.split('=');
            if(searchArr.length >= 2){
                searchObj[searchArr[0]] = searchArr[1];
            }
        });

        return searchObj;
    },

    //设置cookie
    setCookie: function (cname, cvalue, exdays, domain, path) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        var path = path ? ";path=" + path : '/';
        var domain = domain ? ";domain=" + domain : '';
        document.cookie = cname + "=" + cvalue + "; " + expires + domain + path;
    },
    //清除cookie
    clearCookie: function (name, domain, path) {
        this.setCookie(name, "", -1, domain, path);
    },

    getCookie: function (cookieName) {
        var _name = cookieName + '=',
            _cArray = document.cookie.split(';');
        for (var i = 0; i < _cArray.length; i++) {
            var _cItem = _cArray[i];
            while (_cItem.charAt(0) === ' ') {
                _cItem = _cItem.substring(1);
            }
            if (_cItem.indexOf(_name) !== -1) {
                return _cItem.substring(_name.length, _cItem.length)
            }
        }
        return '';
    },

    ge_flag: function () {
        return new function () {
            return {
                val: false,

                set() {
                    this.val = true;
                    setTimeout(() => {
                        this.val = false;
                    }, 2000)
                },

                get() {
                    return this.val
                }
            }
        }
    }
};

module.exports = tool;



// WEBPACK FOOTER //
// ./src/assets/util/tool.js